import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const CheckBoxTickFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.07 3.2h7.85a4.87 4.87 0 0 1 4.87 4.87v7.85a4.87 4.87 0 0 1-4.87 4.87H8.07a4.87 4.87 0 0 1-4.87-4.87V8.07A4.87 4.87 0 0 1 8.07 3.2Zm8.616 6.366a.8.8 0 0 0-1.132-1.132l-5.503 5.504-2.054-2.063a.8.8 0 1 0-1.134 1.13l2.62 2.63a.8.8 0 0 0 1.133 0l6.07-6.07Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CheckBoxTickFilled
